import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { formatDateByDayFullMonthYear } from 'lib/date';
import { getStoreImageUrl, toStoreImageAltText } from 'lib/image';
import { capitalizeEveryWord } from 'lib/string';

import APP from 'constants/app';

// Parse date-only ISO string with T00:00:00 to avoid UTC midnight
// offset showing the previous day for BRT (UTC-3) users.
const parseServerDate = (serverDate) =>
  serverDate ? new Date(`${serverDate}T00:00:00`) : new Date();

const getHeadingText = (isExclusivelyCoupon, storeName, date) => {
  if (!isExclusivelyCoupon) {
    return `Ofertas e cupons ${storeName}  `;
  }

  const month = date.toLocaleDateString('pt-BR', { month: 'long' });
  const year = date.getFullYear();

  return `Cupons ${storeName} ${capitalizeEveryWord(month)} ${year}  `;
};

const StoreSummary = ({
  isExclusivelyCoupon,
  isStoreVerified,
  serverDate,
  storeDomain,
  storeImage,
  storeName,
}) => {
  const date = parseServerDate(serverDate);

  return (
    <header className="grid auto-cols-max gap-x-4 gap-y-1 lg:gap-x-6">
      <Avatar
        className="row-span-2"
        description={toStoreImageAltText(storeName)}
        icon="store"
        size="size1"
        src={
          storeImage.startsWith(APP.LOCAL_IMAGE_PATH)
            ? storeImage
            : getStoreImageUrl(storeImage, 85)
        }
      />
      <Heading
        as="h1"
        className="col-start-2 inline-flex max-w-72 items-center whitespace-break-spaces lg:max-w-full"
        size="size2"
      >
        {getHeadingText(isExclusivelyCoupon, storeName, date)}
        {isStoreVerified && <Icon name="verified-color" size="size3" />}
      </Heading>
      {storeDomain && (
        <Text className="col-start-2 row-start-2 text-neutral-high-500">
          {storeDomain}
        </Text>
      )}
      {isExclusivelyCoupon && (
        <Text
          className="col-start-2 row-start-3 text-neutral-high-500"
          size="size1"
        >
          Atualizado em {formatDateByDayFullMonthYear(date)}
        </Text>
      )}
    </header>
  );
};

StoreSummary.propTypes = {
  isExclusivelyCoupon: PropTypes.bool,
  isStoreVerified: PropTypes.bool.isRequired,
  serverDate: PropTypes.string,
  storeDomain: PropTypes.string,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};

export default StoreSummary;
